<template>
  <div class="OutermostLayer">
    <el-container style="width: 100%;height: 100%;margin: 0px">
      <el-aside class="asideClass">
        <div style="color: white;font-size: 24px;">数据库信息</div>
        <div style="margin-top: 10px;color: white;font-size: 18px;">节点标签 {{ labelCondition }}</div>
        <el-divider></el-divider>
        <div>
          <div v-for="(item,index) in labelList" :key="index" class="labelClass" @click="loadGraphByLabel(item)">{{ item }}</div>
        </div>
        <div style="margin-top: 10px;color: white;font-size: 18px;">关系类型 {{ relationshipCondition }}</div>
        <el-divider></el-divider>
        <div>
          <div v-for="(item,index) in relationshipTypeList" :key="index" class="labelClass" @click="loadGraphByRelationship(item)">{{ item }}</div>
        </div>
      </el-aside>

      <el-main class="mainClass">
        <el-container>
          <el-header>
            <el-row>
              <div v-for="(item,index1) in this.nodeTitleInfoList" :key="'1-' + index1" style="display: inline;margin: 0 5px">
                <el-button round @click="openNodeStyle(item,index1,1)" :style="{background: nodeColors[index1],color: '#000000',fontSize: 'large'}" :disabled="index1 === 0" >{{ item.type }}({{ item.num}})</el-button>
              </div>
              <div style="float: right;margin-right: 0px" class="searchClass">
                <el-input type="text" v-model="textValue" placeholder="请输入内容"/>
                <el-select
                  class="select-item-mode1"
                  style="width: 150px"
                  placeholder="请选择"
                  v-model="choose"
                >
                 <el-option v-for="item in selectionList" :key="item.value" :label="item.label" :value="item.value"/>
                </el-select>
                <el-select
                  class="select-item-mode1"
                  style="width: 150px"
                  placeholder="请选择"
                  v-model="operate"
                >
                  <el-option label="添加" value="添加"></el-option>
                  <el-option label="查看" value="查看"></el-option>
                  <el-option label="清空" value="清空"></el-option>
                  <el-option label="搜索" value="搜索"></el-option>
                </el-select>
                <el-button type="primary" @click="operateEvent">确定</el-button>
              </div>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <div v-for="(item,index2) in this.edgeTitleInfoList" :key="'2-' + index2" style="display: inline;margin: 0 5px">
                <el-button @click="openNodeStyle(item,index2,2)" :style="{background: edgeColors[index2],color: 'white',fontSize: 'large'}">{{ item.type }}({{ item.num}})</el-button>
              </div>
            </el-row>
          </el-header>
          <el-main style="width: 99%;margin: 50px 0px 0px 0px;">
            <div id="container"></div>
          </el-main>
          <el-footer class="footer">
            <div class="commentFooter" v-if="footerStatus == 0">
              <div class="commentFooter" v-if="mouseStatus == 1">
                <div class="commentNode" :style="{backgroundColor: mouseEventFill}"> {{ nodeText }}</div>
                <div v-for="(item,nodeIndex) in nodeCaptions" :key="'node-' + nodeIndex" style="font-size: 15px">
                  <span style="font-weight: bold;">{{ item }}：</span>
                  <span style="margin-right: 5px;">{{ nodeObj[item].length > 20 ? nodeObj[item].substring(0,20) + "..." : nodeObj[item] }}</span>
                </div>
              </div>
              <div class="commentFooter" v-else-if="mouseStatus == 2">
                <div class="commentEdge" :style="{backgroundColor: mouseEventFill}"> {{ edgeText }}</div>
                <div v-for="(item,edgeIndex) in edgeCaptions" :key="'edge-' + edgeIndex" style="font-size: 15px">
                  <span style="font-weight: bold;">{{ item }}：</span>
                  <span style="margin-right: 10px;">{{ edgeObj[item] }}</span>
                </div>
              </div>
              <div v-else style="font-size: 20px" >
                显示 <span style="font-weight: bold;">{{ initNodes.length }}：</span>节点，<span style="font-weight: bold;"> {{ initEdges.length }} </span> 关系
              </div>
            </div>
            <div class="commentFooter" v-if="footerStatus != 0">
              <div class="commentNode" :style="{backgroundColor: fill}" v-show="footerStatus == 1"> {{ nodeType }}</div>
              <div class="commentEdge" :style="{backgroundColor: fill}" v-show="footerStatus == 2"> {{ edgeType }}</div>
              <span class="commentText">颜色：</span>
              <div v-for="(item,colorIndex) in colors" :key="'color-' + colorIndex" style="margin-right: 10px">
                <el-button @click="updataNodeStyle(colorIndex)" size="small" circle :style="{backgroundColor: colors[colorIndex],padding: '10px',margin: '0px 3px'}"></el-button>
              </div>
              <span class="commentText">说明文字：</span>
              <div v-for="(item,attIndex) in Captions" :key="'att-'+ attIndex" style="margin-right: 5px">
                <el-button @click="updataLabelStyle(item,footerStatus)" plain type="info" size="medium" style="font-size: 15px"> {{ item }} </el-button>
              </div>
            </div>
          </el-footer>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import userapi from "@/api/user";
import {generateColorArray} from "../../utils/index";
import G6 from '@antv/g6';
export default {
  data() {
    return {
      labelList: [],
      labelTotal: 0,
      relationshipTypeList: [],
      relationshipCount: 0,
      labelColors: [],
      labelCondition: null,
      relationshipCondition: null,

      choose: null,
      textValue: null,
      operate: "添加",

      graph: null,
      nodeObj: null,
      edgeObj: null,
      initNodes: [],
      initEdges: [],
      lastNodes: [],
      lastEdges: [],
      updataStatus: false,
      nodeIndex: null,
      edgeIndex: null,
      nodeTitleInfoList: null,
      edgeTitleInfoList: null,
      nodeColors: [],
      edgeColors: [],
      colors: ["#c990c0","#ffe081","#f79767","#f16667","#57c7e3","#d9c8ae","#8dcc93","#ecb5c9","#4c8eda","#ffc454","#da7194","#569480"],
      nodeType: null,
      edgeType: null,
      nodeText: null,
      edgeText: null,
      fill: null,
      mouseEventFill: null,
      objAttIndex: 0,
      footerStatus: 0,
      statusNum: -1,
      mouseStatus: -1, // 1是节点 2是边
      status: false,
      nodeCaptions: [],
      edgeCaptions: [],
      Captions: [],

      mapping: {
        name: "名字",
        path: "路径",
        Authors: "作者",
        description: "描述",
        title: "名称",
        Abstract: "摘要",
        uri: "uri",
        CLC: "中心逻辑电路与控制",
        Journal: "杂志",
        ISSN: "国际标准序号",
        BookEngNmae: "图书工程师姓名",
        Year: "年",
        baseInfoValueList: "基本信息值列表",
        Keywords: "关键词",
        year: "年份",
        ISBN: "国际标准图书编号",
        Language: "语言",
        openTypeList: "打开类型列表",
        area: "地区",
        image: "照片",
        url: "url",
        JournalEngName: "出版社名称",
        ArticleEngName: "文章名称",
        detail: "详情",
        baseInfoKeyList: "基本信息密钥列表",
      },
      selectionList: [],
      searchList: [],
      label: [],
    }
  },
  methods: {
    /**
     * 初始化获取搜索的标签内容   返回属性较多的前四个属性
     */
    initSearchLabel(){
      userapi.getRequest("/knowledgeGraph/getAttributes",).then(res=>{
        // console.log("resA",res)
        this.selectionList = [];
        this.labels = res.data;
        res.data.forEach((item,index)=>{
          for (let key in item) {
            for (let mappingKey in this.mapping) {
              if (key == mappingKey) {
                this.selectionList.push({
                  value: mappingKey,
                  label: this.mapping[mappingKey],
                })
              }
            }
          }
        })
        // console.log("this.selectionList",this.selectionList)
      })
    },
    /**
     * 触发操作事件
     */
    operateEvent(){
      // console.log("this.operate",this.operate)
      if (this.operate == "添加"){
        if (this.choose == null || this.textValue == null || this.choose == "" || this.textValue == ""){
          this.$message({
            message: '请输入内容',
            type: 'warning'
          });
          return;
        }
        let label = this.choose;
        let type = [];
        this.labels.forEach(item=>{
          for (let key in item) {
            if (key == label){
              type = item[key];
            }
          }
        })
        this.searchList.push({
          value: this.textValue,
          label: label,
          type: type,
          labelName: this.mapping[label],
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        });

        // console.log("this.searchList",this.searchList)
      }else if (this.operate == "查看"){
        let message = "";
        this.searchList.forEach(item=>{
          // console.log("111",item)
          message += item.labelName + "：" + item.value + "\r\n"
        })
        this.$notify({
          title: '成功',
          message: message,
          type: 'success'
        });
      }else if (this.operate == "清空"){
        this.searchList = [];
        this.$message({
          message: '清空成功',
          type: 'success'
        });
      }else if (this.operate == "搜索"){
        let param = [];
        this.searchList.forEach(item=>{
          param.push({
            attribute: item.label,
            typeList: item.type,
            condition: item.value
          })
        })
        userapi.postUrl("/knowledgeGraph/getDataByConditionSearch", param).then(res=>{
          this.renderCanvas(res)
        })
      }
    },
    /**
     * 通过关系类型查找数据
     * @param key
     */
    loadGraphByRelationship(item) {
      userapi.getRequest("/knowledgeGraph/getAllDataByRelationship", {key:item}).then(res=>{
        this.renderCanvas(res)
      })
    },
    /**
     *  修改节点和边的文字样式
     */
    updataLabelStyle(item,footerStatus) {
      let type;
      if (footerStatus == 1) { // 修改节点的文字样式
        type = this.nodeType;
        this.lastNodes.forEach(node => {
          if (node.type == type) {
            node.label = node[item];
            this.graph.updateItem(node.id,node)
          }
        })
      }else if (footerStatus == 2) {  // 修改边的文字样式
        type = this.edgeType;
        this.lastEdges.forEach(edge => {
          if (this.edgeType == "*"){ //改变全部
            edge.label = edge[item];
            this.graph.updateItem(edge.id,edge)
          }else {
            if (edge.type == type) {  //改变 type == this.edgeType 的
              edge.label = edge[item];
              this.graph.updateItem(edge.id,edge)
            }
          }
        })
      }
    },
    /**
     * 修改 节点和边的样式
     * @param index
     */
    updataNodeStyle(index) {
      let type;
      if (this.footerStatus == 1){ //修改节点样式
        type = this.nodeType;
        this.lastNodes.forEach(node => {
          if (node.type == type) {
            node.style = {
              fill: this.colors[index],
            }
            this.graph.updateItem(node.id,node)
          }
        })
        this.nodeColors[this.nodeIndex] =  this.colors[index];
        this.fill = this.colors[index];

      }else if (this.footerStatus == 2){ //修改边样式
        type = this.edgeType;
        this.lastEdges.forEach(edge => {
          if (this.edgeType == "*"){
            edge.style = {
              stroke: this.colors[index],
              lineWidth: 5,
              endArrow: {
                path: G6.Arrow.triangle(15, 25, 25),
                d: 25,
                fill: this.colors[index],
              },
            }
            this.graph.updateItem(edge.id,edge)
          } else {
            if (edge.label == type) {
              edge.style = {
                stroke: this.colors[index],
                lineWidth: 5,
                endArrow: {
                  path: G6.Arrow.triangle(15, 25, 25),
                  d: 25,
                  fill: this.colors[index],
                },
              }
              this.graph.updateItem(edge.id,edge)
            }
          }
        })
        if (this.edgeType == "*"){
          for (let i = 0; i < this.edgeColors.length; i++) {
            this.edgeColors[i] =  this.colors[index];
          }
        }else {
          this.edgeColors[this.edgeIndex] =  this.colors[index];
        }
        this.fill = this.colors[index];
        // document.getElementById("edge").style.background =  this.colors[index];
        this.$forceUpdate()
      }
    },
    /**
     * 点击类型展开信息
     * @param item 点击的类型
     * @param index
     * @param type
     */
    openNodeStyle(item,index,type) {
      if (type == 1){  // 节点样式
        this.footerStatus = 1;
        this.nodeType = item.type;
        this.fill = this.nodeColors[index];
        this.nodeIndex = index;
        this.Captions = this.nodeCaptions;
        this.$forceUpdate()
      }else { // 边样式
        this.footerStatus = 2;
        this.edgeType = item.type;
        this.fill = this.edgeColors[index];
        this.edgeIndex = index;
        this.Captions = this.edgeCaptions;
        this.$forceUpdate()
      }


    },
    /**
     * 加载关系图
     * @param item
     */
    loadGraphByLabel(item){
      userapi.getRequest("/knowledgeGraph/getAllDataByLabels", {key:item}).then(res=>{
        this.renderCanvas(res)
      })
    },
    /**
     * 鼠标移入和移出时改变颜色
     * @param index
     * @param isHovered
     */
    updateLabelColor(index,isHovered){
      if (isHovered){
        this.labelColors[index] = '#ffffff';
      }else {
        this.labelColors[index] = '#9195a0';
      }
      // console.log(this.labelColors)
    },
    /**
     * 初始化加载左边的标签信息
     */
    init() {
      userapi.getRequest("/knowledgeGraph/getAllLabels", null).then((res) => {
        this.labelList = res.data.labelList;
        this.labelTotal = parseInt(res.data.labelTotal);
        this.labelList.unshift("*(" + this.labelTotal + ")");
        this.relationshipTypeList = res.data.relationshipTypeList;
        this.relationshipCount = parseInt(res.data.relationshipCount);
        this.relationshipTypeList.unshift("*(" + this.relationshipCount + ")");

        this.labelList.forEach(item => {
          this.labelColors.push("#9195a0")
        })
      })
    },
    /**
     * 渲染画布
     * @param res
     */
    renderCanvas(res){
      // console.log("res",res)
      if (this.graph) {
        this.graph.destroy();
      }
      // 节点和关系赋值
      this.initNodes = res.data.nodes;
      this.initEdges = res.data.edges;

      /**
       * 赋值文字说明字段数组
       */
      this.nodeCaptions = res.data.nodeCaptions;
      this.edgeCaptions = res.data.edgeCaptions;
      // console.log("this.nodeCaptions",this.nodeCaptions)
      // console.log("this.edgeCaptions",this.edgeCaptions)

      let nodeLabels = {};
      nodeLabels['*'] = res.data.nodes.length;
      res.data.nodes.forEach((item) => {
        if (nodeLabels[item.type]) {
          nodeLabels[item.type]++;
        } else {
          nodeLabels[item.type] = 1;
        }
      });
      /**
       * {
       * "Class": 147,
       * "Property": 2,
       * "Relationship": 1
       * }
       */
      let nodeListInfo = Object.entries(nodeLabels).map(([type, num]) => ({
        type,
        num,
      }));
      this.nodeTitleInfoList = nodeListInfo.sort(function(a, b) {return b.num - a.num;});

      let edgeLabels = {};
      edgeLabels['*'] = res.data.edges.length;
      res.data.edges.forEach((item) => {
        if (edgeLabels[item.type]) {
          edgeLabels[item.type]++;
        } else {
          edgeLabels[item.type] = 1;
        }
      });

      let edgeListInfo = Object.entries(edgeLabels).map(([type, num]) => ({
        type,
        num,
      }));
      this.edgeTitleInfoList = edgeListInfo.sort(function(a, b) {return b.num - a.num;});

      // 初始化G6显示
      let container = document.getElementById('container');
      let width = container.scrollWidth;
      let height = container.scrollHeight ;

      this.graph = new G6.Graph({
        container: 'container',
        width,
        height,
        fitCenter: true,
        modes: {
          default: ['zoom-canvas', 'drag-canvas', 'drag-node'],
        },
        layout: {
          type: 'force',
          preventOverlap: true,
          kr: 10,
          nodeSize: 350,
          center: [250, 250],
        },
        defaultNode: {
          size: [100,100],
        },
      });

      res.data.nodes.forEach(node => {
        node.x = Math.random() * 1;
      });

      this.nodeColors = generateColorArray(this.nodeTitleInfoList.length);
      this.edgeColors = [];
      this.edgeTitleInfoList.forEach(i =>{
        this.edgeColors.push('#909399')
      })

      this.nodeTitleInfoList.forEach((nodeInfo,index) => {
        if (index > 0){
          res.data.nodes.forEach(node => {
            if (node.type == nodeInfo.type){
              node.label = node.name;
              node.style = {
                fill: this.nodeColors[index]
              }
              node.labelCfg = {
                position: 'center', // 其实默认就是 center，这里写出来便于理解
                style: {
                  fontSize: 15,     // 文本字体大小
                  // lineWidth: 2,     // 文本描边粗细
                  // stroke: '#ffffff',     // 文本描边颜色
                  fill: '#000000',  // 文本颜色
                }
              }
            }
          })
          res.data.edges.forEach(edge => {
            edge.label = edge.type;
            edge.style = {
              stroke: "#a5abb6",
              lineWidth: 5,
              endArrow: {
                path: G6.Arrow.triangle(15, 25, 25),
                d: 25,
                fill: '#a5abb6',
              },
            }
            edge.labelCfg = {
              position: 'center', // 其实默认就是 center，这里写出来便于理解
              autoRotate: true,   // 使文本随边旋转
              style: {
                stroke: 'white',  // 给文本添加白边和白色背景
                lineWidth: 5,     // 文本白边粗细
                fill: '#000000',  // 文本颜色
              }
            }
          })
        }
      })

      this.graph.on('node:mouseenter', (ev) => {
        this.mouseStatus = 1;
        this.statusNum = this.footerStatus;
        this.footerStatus = 0;
        this.nodeObj = ev.item._cfg.model;
        this.nodeText = this.nodeObj.type
        this.nodeTitleInfoList.forEach((item,index) => {
          if (item.type == this.nodeObj.type){
            this.mouseEventFill = this.nodeColors[index];
          }
        })
      });

      this.graph.on('node:mouseleave', (ev) => {
        this.mouseStatus = -1;
        this.footerStatus = this.statusNum;
      });

      this.graph.on('edge:mouseenter', (ev) => {
        this.mouseStatus = 2;
        this.statusNum = this.footerStatus;
        this.footerStatus = 0;
        this.edgeObj = ev.item._cfg.model;
        this.edgeText = this.edgeObj.type;
        this.edgeTitleInfoList.forEach((item,index) => {
          if (item.type == this.edgeObj.type){
            this.mouseEventFill = this.edgeColors[index];
          }
        })
      });

      this.graph.on('edge:mouseleave', (ev) => {
        this.mouseStatus = -1;
        this.footerStatus = this.statusNum;
      });

      this.graph.on('canvas:click', (ev) => {
        this.footerStatus = 0;
      });

      this.graph.on('node:dblclick', (ev) => {
        let node = ev.item._cfg.model;
        userapi.getRequest("/knowledgeGraph/getDataByNodeId", {id:node.id}).then(res=>{
          let edgeCaptions = res.data.edgeCaptions;
          let edges = res.data.edges;
          let nodeCaptions = res.data.nodeCaptions;
          let nodes = res.data.nodes;
          edgeCaptions.forEach(edgeCaption => {
            if (!this.edgeCaptions.includes(edgeCaption)) {
              this.edgeCaptions.push(edgeCaption);
            }
          })
          edges.forEach(edge => {
            // 在 lastEdges 中查找是否有与当前 edge id 相同的对象
            const existingEdge = this.lastEdges.find(lastEdge => lastEdge.id == edge.id);

            // 如果在 lastEdges 中没有找到与当前 edge id 相同的对象，将当前 edge 添加到 lastEdges
            if (!existingEdge) {
              this.lastEdges.push(edge);
            }
          });
          nodeCaptions.forEach(nodeCaption => {
            if (!this.nodeCaptions.includes(nodeCaption)) {
              this.nodeCaptions.push(nodeCaption);
            }
          })
          nodes.forEach(node => {
            // 在 lastNodes 中查找是否有与当前 node id 相同的对象
            const existingNode = this.lastNodes.find(lastNode => lastNode.id == node.id);

            // 如果在 lastNodes 中没有找到与当前 node id 相同的对象，将当前 node 添加到 lastNodes
            if (!existingNode) {
              this.lastNodes.push(node);
            }
          });
          let newRes = {
            data:{
              nodes: this.lastNodes,
              nodeCaptions: this.nodeCaptions,
              edges: this.lastEdges,
              edgeCaptions: this.edgeCaptions,
            }
          }
          // console.log("newRes",newRes)
          this.renderCanvas(newRes)
        })
      });

      // 节点和关系赋值
      this.lastNodes = res.data.nodes;
      this.lastEdges = res.data.edges;

      this.graph.data(res.data);
      this.graph.render();

      if (typeof window !== 'undefined')
        window.onresize = () => {
          if (!this.graph || this.graph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          this.graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
    }
  },
  created(){

  },
  destroyed(){

  },
  mounted() {
    this.init();
    this.initSearchLabel();
  }
}
</script>

<style scoped>
  .OutermostLayer{
    width: 100%;
    height: 100%;
    margin: 0px;
    text-align: left;
  }

  .asideClass{
    width: 30%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    overflow-y: auto;
    background: #30333a;
  }

  .mainClass{
    width: 100%;
    height: 100%;
    background: #d2d5da;
  }

  .labelClass{
    padding: 4px 7px;
    margin: 3px;
    background: #9195a0;
    border-radius: 10%;
    display: inline-block;
    font-size: 14px;
  }

>>> .asideClass .el-divider--horizontal{
  margin: 5px 0px;
}


  >>> .el-divider--horizontal{
    margin: 15px 0;
  }

  .footer {
    position: fixed; /* 将底部区域固定在屏幕底部 */
    bottom: 50px;
    width: 100%;
  }
  #container{
    width: 98%;
    /*margin: 0 auto;*/
    height: calc(100vh - 350px);
    overflow: hidden;
  }

  .commentFooter {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .commentText {
    font-size: 20px;
    color: dimgray;
  }

  .commentNode {
    color: black;
    border-radius: 50%;
    margin-right: 10px;
    padding: 10px;
    font-weight: bold;
    font-size: 20px;
  }

  .commentEdge {
    color: black;
    border-radius: 10px;
    margin-right: 10px;
    padding: 10px;
  }

>>> .searchClass .el-input{
  width: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/neo4j.vue